export default __webpack_public_path__ + "49c42f274c5b7a9f329ec052881fe4f0.svg";